import { connect } from 'react-redux';
import {
  saveJournalSection,
  selectConcept,
  selectRevision,
  toggleDesignSummary,
} from '../../actions/journal';
import { saveNotes, openRevision } from '../../actions/filemanager';
import EngineeringLogs from '../../components/Journal/EngineeringLogs';

const mapStateToProps = (state) => {
  const { concepts, revisions } = state.filemanager;
  const {
    designSummary,
    showDesignSummary,
    selectedConceptName,
    selectedRevisionId,
  } = state.journal;
  const designFields = state.app.designFields;
  const loadingFileManager = state.filemanager.loading.command;
  const defaultSpecification = {
    id: state.app.specification.id,
    name: state.app.specification.name,
  };

  let selectedConcept, selectedRevision;
  if (selectedConceptName) {
    selectedConcept = concepts.find((c) => c.name === selectedConceptName);
  }
  if (selectedRevisionId) {
    selectedRevision = revisions.find((r) => r.id === selectedRevisionId);
  }

  return {
    designSummary,
    showDesignSummary,
    selectedConcept,
    selectedRevision,
    defaultSpecification,
    concepts,
    revisions,
    designFields,
    loadingFileManager,
  };
};

export default connect(mapStateToProps, {
  saveJournal: saveJournalSection,
  selectRevision,
  selectConcept,
  toggleDesignSummary: toggleDesignSummary,
  saveNotes: saveNotes,
  openRevision: openRevision,
})(EngineeringLogs);
